
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import CONSTANTS from '../../../constants';
import { priceFormat } from '../../../helpers/functions';
import { CheckBox, Radio } from "../../Forms/Forms";
import './forfaitRevisionItem.css';
const mapStateToProps = state => state;

class ForfaitRevisionItem extends PureComponent {
  static defaultProps = {
    className: "",
    selectedForfait: "",
    data: {},
    TotalPrice: 0,
    showComments: false,
  };
  constructor(props) {
    super(props);
    this.state = {
      selectedForfait: "",
      showObligatoryMessage: false,
      showItemDetails: false,
    }
    this.currencyPlacement = !!Number(window.siteConfig.PoundPlacement);
  }
  updatePrice = () => {
    let totalPrice = this.props.data.Items[0].Prix;
    if (this.props.data.Operations != null)
      this.props.data.Operations.map(function (operation, keyopp) {
        if (operation.isSelected)
          totalPrice += operation.Items[0].Prix;
      });

    this.setState({ TotalPrice: totalPrice });
  };
  componentDidMount() {
    let totalPrice = this.props.data.Items[0].Prix;
    if (this.props.data.Operations != null)
      this.props.data.Operations.map(function (operation, keyopp) {
        if (operation.isSelected)
          totalPrice += operation.Items[0].Prix;
      });

    this.setState({ TotalPrice: totalPrice });

  }

  render() {
    const forfait = this.props.data;
    const arrowObligatoryClasses = (this.state.showObligatoryMessage ? 'isOpen' : '');
    return (
      <React.Fragment>
        <div className="service-item__wrapper">
          <div className="form_input service-item__ligne">
            <Radio label={forfait.Libelle}
              id={forfait.Items[0].Ref}
              value={forfait.Items[0].Ref}
              name={this.props.familyCode}
              onChange={(e) => {
                this.updatePrice()
                this.setState({ selectedForfait: e.target.value });
                this.props.updateSelectedForfait(e.target.checked, forfait.Items[0].Ref);
                this.props.enableAddButton(e.target.checked);
              }
              }
              isChecked={this.props.data.isSelected}
            />
            {!!forfait.Comments.length && <span className="icon__arrow" onClick={() => this.setState({ showComments: (this.state.showComments ? false : true) })}></span>}
          </div>
          {this.state.showComments && <div className="forfait-revision-single-comment service-item__details">
            {typeof forfait.Comments == 'object' && forfait.Comments.length && forfait.Comments.map(function (item, key) {
              return <span key={key}>{key + 1} - {item.Text}<br /></span>;
            })}
            {typeof forfait.Comments == 'string' && forfait.Comments.length && <span> {forfait.Comments} <br /></span>}

          </div>}
        </div>
        {(this.props.data.isSelected) && <div className="forfait-revision-single-content">

          <ul>
            <li className="section-title">
              <div className="section-title-wrapper service-item__ligne">
                <div className="form-wrapper">
                  <span className="label-title">{CONSTANTS.LABELS.needs_basket_maintenance_label6}</span>
                </div>

              </div>
            </li>
            <li className="default-forfait-wrapper">

              <div className="form_input service-item__ligne">
                <div className="form-wrapper">
                  <span className="default-forfait--title"> {forfait.Libelle}</span>
                  {!!forfait.Comments.length &&
                    <span className="icon__arrow" onClick={() => (this.state.showItemDetails != forfait.Items[0].Ref ? this.setState({ showItemDetails: forfait.Items[0].Ref }) : this.setState({ showItemDetails: false }))}>
                    </span>}
                </div>


              </div>
              <div className="item_price service-item__ligne">
                <span className="item_price">
                  {priceFormat(forfait.Items[0].Prix)}{` ${CONSTANTS.LABELS.needs_basket_label2}`}
                </span>
              </div>
              {
                this.state.showItemDetails && this.state.showItemDetails == forfait.Items[0].Ref &&
                <div className="service-item__details">
                  {typeof forfait.Comments == 'object' && forfait.Comments.map(function (item, key) {
                    return <span key={'comment-' + key}>{key + 1} - {item.Text}<br /></span>;
                  })}
                  {typeof forfait.Comments == 'string' && <span> {forfait.Comments} <br /></span>}
                </div>
              }
            </li>
           {forfait.Operations != null && <li className="section-title">
              <div className="section-title-wrapper service-item__ligne">
                <div className="form-wrapper">

                  <span className="label-title" dangerouslySetInnerHTML={{ __html: (CONSTANTS.LABELS.needs_basket_maintenance_label7) }}></span>

                </div>
              </div>
              <div className="service-item__ligne item_icon">
                <span className={`icon__arrow size-medium ${arrowObligatoryClasses}`} onClick={() => this.setState({ showObligatoryMessage: (this.state.showObligatoryMessage ? false : true) })}></span>
              </div>
              {this.state.showObligatoryMessage && <p className="label-details" dangerouslySetInnerHTML={{ __html: (CONSTANTS.LABELS.needs_basket_maintenance_label8) }}></p>}


            </li>}
            {forfait.Operations != null && forfait.Operations.map(function (operation, keyopp) {
              return (<li key={keyopp} >
                <div className="form_input service-item__ligne">
                  <CheckBox
                    label={operation.Libelle}
                    id={operation.Items[0].Ref}
                    isChecked={operation.isSelected}
                    onClick={(e) => {
                      this.props.updateSelectedOperation(e.target.checked, operation.Items[0].Ref);
                      if (e.target.checked) {
                          this.setState({ TotalPrice: (this.state.TotalPrice + operation.Items[0].Prix) });
                      } else {
                          this.setState({ TotalPrice: (this.state.TotalPrice - operation.Items[0].Prix) });
                        }
                      }

                    } />
                  {!!forfait.Comments.length &&
                    <span className="icon__arrow" onClick={() => (this.state.showItemDetails != operation.Items[0].Ref ? this.setState({ showItemDetails: operation.Items[0].Ref }) : this.setState({ showItemDetails: false }))}>
                    </span>}
                </div>
                <div className="item_price service-item__ligne">
                    <span className="item_price">{`${priceFormat(operation.Items[0].Prix)} ${CONSTANTS.LABELS.needs_basket_label2}`}</span>
                </div>

                {
                  this.state.showItemDetails && this.state.showItemDetails == operation.Items[0].Ref &&
                  <div className="service-item__details">
                    {typeof operation.Comments == 'object' && operation.Comments.map(function (item, key) {
                      return <span key={'comment-' + key}>{key + 1} - {item.Text}<br /></span>;
                    })}
                    {typeof operation.Comments == 'string' && <span> {operation.Comments} <br /></span>}
                  </div>
                }

              </li>)

            }.bind(this))}


          </ul>
          <div className={`price-resulte ${(!!Number(this.props.store.booking.happy) ? 'happy-price' : 'regular-price')}`}>
            <div className="item_price  service-item__ligne">
              {!!Number(this.props.store.booking.happy) && <span className="price_discount">
              {priceFormat(this.state.TotalPrice)}{` ${CONSTANTS.LABELS.needs_basket_label2}`}
              </span>
              }
              <div className="item_finalPrice">
                <h4 className="price-block-title">{CONSTANTS.LABELS.needs_basket_maintenance_label9}</h4>

                <strong>{(!!Number(this.props.store.booking.happy) ? priceFormat(this.state.TotalPrice - (this.state.TotalPrice * 0.01 * this.props.store.booking.happy).toFixed(2)) : priceFormat(this.state.TotalPrice) )}{` ${CONSTANTS.LABELS.needs_basket_label2}`}</strong>
              </div>

              {!!Number(this.props.store.booking.happy) && <span className="happy_discount">{this.props.store.booking.happy}%</span>
              }

            </div>
          </div>
        </div>
        }

      </React.Fragment>
    );
  }
}
export default connect(mapStateToProps)(ForfaitRevisionItem);
